import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ListColumn } from 'src/app/models/list-column.model';
import { HttpClient } from '@angular/common/http';
import { WebinarService } from 'src/app/services/shared/webinar.service';
import { BreadcrumbService } from 'src/app/services/shared/breadcrumb.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ExportComponent } from '../../dashboard/distributor/export/export.component';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { SweetAlertService } from 'src/app/services/sweetalert.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-view-webinar',
  templateUrl: './view-webinar.component.html',
  styleUrls: ['./view-webinar.component.scss']
})
export class ViewWebinarComponent implements OnInit {

  viewWebinar: boolean;
  viewWebinarID: string;

  @Output() backEvent = new EventEmitter<any>();
  @Output() closeToBack = new EventEmitter<any>();
  pageIndex: number = 0;
  pageSize: number = 10;
  isPaid:boolean = false;

  constructor(
    private http: HttpClient,
    private webinarService: WebinarService,
    private breadcrumbService: BreadcrumbService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private localStorageService: LocalStorageService,
    private sweetAlertService: SweetAlertService,
    private dialog: MatDialog,
  ) {
    const paths = this.activatedRoute.snapshot.url;
    this.viewWebinar = paths[1].path === 'view';
    this.viewWebinarID = paths[2]?.path;
    this.oemId = this.getId();
    
  }

  webinarData: any;
  allRegisteredCustomers: any[] = [];
  specialitiesData: any;
  regiteredCustomersData: any[] = [];
  formatwebinarDate: any;
  formatwebinarTime: any;
  formatwebinarDuration: any;
  timeToWebinar: any[] = [];
  date: any;
  oemId: any;
  @Input() returnPath?: string;

  ngOnInit(): void {
    this.getWebinarByID(this.viewWebinarID);
    this.breadcrumbService.setBreadcrumbs(['Dashboard', 'View Webinar']);
  }

  columns: ListColumn[] = []

  setColumns() {
    this.columns = [
      { name: 'S.No', property: 'srNo', visible: true, isModelProperty: false },
      { name: 'Customer Name', property: 'customerName', visible: true, isModelProperty: true, isText: true },
      { name: 'Email', property: 'email', visible: true, isModelProperty: true, isText: true },
      { name: 'Phone', property: 'phoneNumber', visible: true, isModelProperty: true, isText: true },
      { name: 'Registration Number', property: 'registeredNumber', visible: this.isPaid, isModelProperty: true, isText: true },
      { name: 'Address', property: 'customerAddress', visible: true, isModelProperty: true, isText: true },
    ];
  }


  timeLeft(webinarDate: string, webinarTime: any): void {
    const now = new Date();
    const webinarDateTime = new Date(`${webinarDate} ${webinarTime}`);
    const timeDifference = webinarDateTime.getTime() - now.getTime();

    if (timeDifference > 0) {
      const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
      const timeLeft = `${days} days ${hours} hours ${minutes} minutes and ${seconds} seconds`;
      this.timeToWebinar = [days, hours, minutes, seconds];
      setInterval(() => {
        this.timeLeft(this.formatwebinarDate, this.formatwebinarTime);
      }, 1000);
    } else {
    }
  }

  reformatDuration(duration: any): string {
    const hours = duration[0] < 10 ? '0' + duration[0] : duration[0];
    const minutes = duration[1] < 10 ? '0' + duration[1] : duration[1];
    let seconds = '00';
    if (duration.length > 2) {
      seconds = duration[2] < 10 ? '0' + duration[2] : duration[2];
    }
    return `${hours}:${minutes}:${seconds}`;
  }

  reformatTime(time: any): string {
    let hours = time[0];
    const minutes = time[1] < 10 ? '0' + time[1] : time[1];
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    return `${hours}:${minutes} ${ampm}`;
  }

  getSpecialities() {
    this.webinarService.speciality().subscribe((res: any) => {
      const foundSpeciality = res.data.find((x: any) => x.id === this.webinarData.webinarSpecialityId);
      if (foundSpeciality) {
        this.specialitiesData = foundSpeciality.name;
      }
    })
  }

  getAllWebinars() {
    this.webinarService.getAllWebinars().subscribe((res: any) => {
    })
  }

  getWebinarByID(id: string) {
    this.webinarService.getWebinarById(id).subscribe((res: any) => {
      this.webinarData = res.data.webinar;
      if(this.webinarData.paid){
        this.isPaid = true;
      }
      this.setColumns();
      this.allRegisteredCustomers = res.data.regiteredCustomers;
      this.applyPagination();
      if (this.webinarData.webinarDate) {
        this.formatwebinarDate = this.webinarData.webinarDate[0] + '/' +
          this.webinarData.webinarDate[1] + '/' +
          this.webinarData.webinarDate[2];
      }
      if (this.webinarData.webinarTime) {
        this.formatwebinarTime = this.reformatTime(this.webinarData.webinarTime);
        this.timeLeft(this.formatwebinarDate, this.formatwebinarTime);
      }
      if (this.webinarData.duration) {
        this.formatwebinarDuration = this.reformatDuration(this.webinarData.duration);
      }
      if (this.webinarData.webinarSpecialityId) {
        this.getSpecialities();
      }
    });
  }
totalcount:any
  applyPagination() {
    const startIndex = this.pageIndex * this.pageSize;
    const endIndex = Math.min(startIndex + this.pageSize, this.allRegisteredCustomers.length);
    this.regiteredCustomersData = this.allRegisteredCustomers
      .slice(startIndex, endIndex)
      .map((customer, index) => ({
        srNo: startIndex + index + 1,
        ...customer
      }));
      this.totalcount = this.allRegisteredCustomers.length
  }

  handlePageChange(event: any) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.applyPagination();
  }
  onViewRecording(){ let url = this.webinarData.webinarRecordUrl;
    if(url === undefined || url === null || url === 'N/A') return;
    else if (!(url.startsWith('http://') || url.startsWith('https://') || url.startsWith('www'))) return;
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      url = 'https://' + url;
    }
    window.open( url,'_blank');
}

  back(): void {
    if (this.returnPath) {
      this.router.navigate([this.returnPath]);
    } else {
      const urlSegments = this.router.url.split('/').filter(segment => segment);

      if (this.router.url.includes('/view/')) {
        const baseUrlSegments = [];
        for (let i = 0; i < urlSegments.length; i++) {
          baseUrlSegments.push(urlSegments[i]);
          if (i < urlSegments.length - 1 && urlSegments[i + 1] === 'view') {
            break;
          }
        }

        const baseUrl = '/' + baseUrlSegments.join('/');
        this.router.navigate([baseUrl]);
      } else {
        this.router.navigate(['/dashboard']);
      }
    }

    this.closeToBack.emit(true);
    this.backEvent.emit({ actionType: '' });
    this.breadcrumbService.setBreadcrumbs(['Dashboard', 'Webinars']);
  }

  private getId(): string {
    switch (this.localStorageService.getItem('roleName')) {
      case 'DISTRIBUTOR':
        return this.localStorageService.getItem('distributorId');
      case 'OEM':
        return this.localStorageService.getItem('oemId');
      default:
        return this.localStorageService.getItem('userId');
    }
  }
  exportRegisteredCustomers() {
    console.log(this.oemId, "this.oemId");
    
      const dialogRef = this.dialog.open(ExportComponent, {
        height: 'auto',
        width: 'auto',
        data: {
        title: 'WebinarRegisteredCustomers',
        exhibitionId: this.viewWebinarID
        }
      });
      dialogRef.afterClosed().subscribe((result: any) => {
        if (result === 'Success') {
          this.sweetAlertService.showSuccess(result, "File downloaded Sucessfully!!");
        }
      });
    }
}